import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyChipList as MatChipList } from '@angular/material/legacy-chips';
import { trackByValue } from '@y42/angular/util';
import { OperatorEnum } from '@y42/json-schema';
import { ToastService } from '@y42/toast';
import { OperationInputFormService } from '../../operation-input-form.service';

@Component({
  selector: 'y42-operation-input-chip-list[valuesControl][index]',
  templateUrl: './operation-input-chip-list.component.html',
  styleUrls: ['../operation-input-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputChipListComponent {
  constructor(private readonly formService: OperationInputFormService, private readonly toast: ToastService) {}

  @Input() valuesControl!: FormControl<unknown[]>;
  @Input() index!: number;

  @ViewChild(MatChipList) chipList!: MatChipList;

  readonly operationsFormArray = this.formService.operationsFormArray;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, TAB];
  readonly trackByValue = trackByValue;

  addChip(operatorType: OperatorEnum | undefined, chipValue: string, input?: { value: string }): void {
    if (input) {
      input.value = '';
    }

    this.formService.form.markAsDirty();

    const value = chipValue?.trim() || '';
    if (!value) {
      return;
    }

    const index = this.index;
    const values = this.operationsFormArray.controls[index]?.controls.values.value ?? [];
    const i = values.findIndex((arr) => arr === value);

    if (values.length === 1 && (operatorType === OperatorEnum.Equals || operatorType === OperatorEnum.IsNot)) {
      this.toast.info(`Please select only one value`);
    } else if (i === -1) {
      values.push(value);
      this.operationsFormArray.controls[index]?.controls.values.setValue(values);
    } else {
      this.toast.info(`This value already exists`);
    }
  }

  removeChip(value: unknown): void {
    const index = this.index;
    const values = this.operationsFormArray.controls[index]?.controls.values.value ?? [];

    const i = values.findIndex((arr) => arr === value);
    if (i !== -1) {
      values.splice(i, 1);
      this.operationsFormArray.controls[index]?.controls.values.setValue(values);
    }
    this.formService.form.markAsDirty();
  }
}
